module.exports = __webpack_public_path__ + "img/105ne.2a027735.svg";